import { createBrowserRouter } from "react-router-dom";
import Rootstr from "./Rootstr";
import Login from "./Login";
import Register from "./Register";
import Agreement from "./Agreement";
import Getpwd from "./Getpwd";

const router=createBrowserRouter([
  {
    path:'/',
    element:<Rootstr/>
  },
  {
    path:'/login',
    element:<Login/>
  },
  {
    path:'/register',
    element:<Register/>
  },
  {
    path:'/agreement',
    element:<Agreement/>
  },
  {
    path:'/getpassword',
    element:<Getpwd/>
  }
]);
export default router